<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M20 12H4M12.5 5l7.5 7-7.5 7" stroke-width="1.5" />
</svg>
